'use strict';

var FaresOptimizerAnalysisPanelDirective = function FaresOptimizerAnalysisPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FareOptimizerAnalysisPanelController',
    template: require('../templates/fares-optimizer-analysis-panel.html'),
    scope: {
      screenState: '=',
      searchCriteria: '='
    }
  };
};
FaresOptimizerAnalysisPanelDirective.$inject = [];
module.exports = FaresOptimizerAnalysisPanelDirective;